export const PRODUCT_CARD_IMG_HEIGHT = 938;
export const PRODUCT_CARD_IMG_WIDTH = 750;
export const PRODUCT_DETAIL_IMG_HEIGHT = 1876;
export const PRODUCT_DETAIL_IMG_WIDTH = 1500;
